/** a forms input that communicates its value to a wrapping form context */
import {Input, InputProps} from '@chakra-ui/react';
import React from 'react';
import {useFormContext} from 'react-hook-form';

export interface GeoHiddenFieldProps extends InputProps {
	name: string;
	valueAs?: 'number' | 'default' | 'date';
}

export const GeoHiddenField: React.FC<GeoHiddenFieldProps> = ({
	name,
	placeholder,
	valueAs = 'default',
	...props
}: GeoHiddenFieldProps) => {
	const methods = useFormContext();
	return (
		<Input
			ref={methods.register({
				valueAsNumber: valueAs === 'number',
				valueAsDate: valueAs === 'date'
			})}
			name={name}
			type='hidden'
			{...props}
		/>
	);
};
